import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ComponentProps, ReactElement } from "react";

export class TerminalEntry {
  text: ReactElement;
  printHeader: boolean;
  constructor(text: ReactElement, printHeader = true) {
    this.text = text;
    this.printHeader = printHeader;
  }
}

function Terminal({
  folder,
  commands,
  className,
  ...props
}: ComponentProps<"div"> & { folder: string; commands?: TerminalEntry[] }) {
  function userHeader(folder: string) {
    return `user@device ${folder} %`;
  }
  return (
    <div
      className={`flex flex-col gap-5 min-h-120 fit-content break-all w-full max-w-200 bg-stone-800/60 text-text font-mono text-sm backdrop-blur-lg rounded-4xl p-5 ${className}`}
      {...props}
    >
      <div className="flex flex-row items-center justify-between h-fit">
        <div className="flex-1 flex gap-1" aria-hidden="true">
          <a className="relative block w-4 h-4 rounded-full bg-red-500"></a>
          <a className="relative block w-4 h-4 rounded-full bg-yellow-500"></a>
          <a className="block w-4 h-4 rounded-full bg-green-500">&nbsp;</a>
        </div>
        <label
          className="flex-1 text-center text-sm ml-2"
          aria-label="CSICK Mock Terminal"
        >
          {folder}
        </label>
        <span className="flex-1" />
      </div>
      <div>
        {(commands || []).map((command, index) =>
          command.printHeader ? (
            <p key={index}>{userHeader(folder) + " "}{command.text}&nbsp;</p>
          ) : (
            <p key={index}>{command.text}</p>
          ),
        )}
      </div>
    </div>
  );
}
export default Terminal;
